import { render, staticRenderFns } from "./systemCode.vue?vue&type=template&id=c46b5970&scoped=true&"
import script from "./systemCode.vue?vue&type=script&lang=js&"
export * from "./systemCode.vue?vue&type=script&lang=js&"
import style0 from "./systemCode.vue?vue&type=style&index=0&id=c46b5970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46b5970",
  null
  
)

export default component.exports